// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"Em-z","hideOnMobile":"Fm-z"};